export { default as LocalsProductPage } from './ui/LocalsProductPage';
